import { render, staticRenderFns } from "./FinalDonorListMenu.vue?vue&type=template&id=12cdf290"
import script from "./FinalDonorListMenu.vue?vue&type=script&lang=js"
export * from "./FinalDonorListMenu.vue?vue&type=script&lang=js"
import style0 from "./FinalDonorListMenu.vue?vue&type=style&index=0&id=12cdf290&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports